import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateWriteoffDetailAction as updateWriteoffDetail } from '../../../../../services/WriteoffService/slice';

export const WriteoffAmountField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentWriteoff } = useAppSelector(state => state.writeoff);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    
    // Allow empty string (for clearing the field)
    if (inputValue === '') {
      dispatch(updateWriteoffDetail({ writeoffAmount: 0 }));
      return;
    }
    
    // Parse the value, but don't fallback to 0 if invalid
    const value = parseFloat(inputValue);
    if (!isNaN(value)) {
      dispatch(updateWriteoffDetail({ writeoffAmount: value }));
    }
  };

  // Get the display value - show empty string if amount is 0, otherwise show the actual amount
  const getDisplayValue = () => {
    const amount = currentWriteoff?.detail?.writeoffAmount;
    if (amount === undefined || amount === null || amount === 0) {
      return '';
    }
    return amount.toString();
  };

  return (
    <TextField
      label="Writeoff Amount"
      type="number"
      value={getDisplayValue()}
      onChange={handleChange}
      size="small"
      required
      inputProps={{ min: 0, step: 0.01 }}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
      sx={{ flex: 1, maxWidth: 200 }}
    />
  );
};

export default WriteoffAmountField;
